import styles from "./navbar.module.css"
import { Link } from "react-router-dom"
import { RiArrowDropDownLine } from 'react-icons/ri';

const Navbar = () => {
    return (
        <nav className={styles.container}>

            {/* logo */}
            <div className={styles.logo}>
                <Link to="/" className={styles.logoText}></Link>
            </div>
            {/* navlinks */}
            <div className={styles.navLinksWrapper}>
                <Link to="/about" className={styles.navLink}>about <span><RiArrowDropDownLine className={styles.dropdownIcon} /></span></Link>
                <Link to="/about" className={styles.navLink}>payments</Link>
                <Link to="/login" className={styles.navLink}>developer tools<span><RiArrowDropDownLine className={styles.dropdownIcon} /></span></Link>
                <Link to="/login" className={styles.navLink}>support<span><RiArrowDropDownLine className={styles.dropdownIcon} /></span></Link>
            </div>
            {/* authlinks */}
            <div className={styles.authLinksWrapper}>
                <Link to="/login" type="button" className={styles.loginBtn}>login</Link>
                <Link type="button" to="/register" className={styles.createBtn}>Create account</Link>
            </div>

        </nav>
    )
}

export default Navbar

